import { render, staticRenderFns } from "./addressWarning.vue?vue&type=template&id=533959d1&scoped=true&"
import script from "./addressWarning.vue?vue&type=script&lang=js&"
export * from "./addressWarning.vue?vue&type=script&lang=js&"
import style0 from "./addressWarning.vue?vue&type=style&index=0&id=533959d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533959d1",
  null
  
)

export default component.exports